import type { LayoutLoad } from './$types';
			import type { CategoryData } from '$lib/metadataTypes/MetaTypes';
			
			export const load: LayoutLoad = async ({ parent }): Promise<CategoryData> => {
				const { site } = await parent(); // parent() = SiteData
				return {
					site,
					category: {
							title: "Freon and LionWeb — Towards Interoperable Language Workbenches",
description: "Learn how Freon integrates with the LionWeb ecosystem to enable interoperability between language workbenches, shared metamodels, and web-based tooling.",
tags: [ "LionWeb", "interoperability", "language workbench", "metamodel", "web tooling", "DSL ecosystem", "Freon"] 
					}
				};
			};